import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';
import School from '../../../models/School';
import District from '../../../models/District';

const DistrictSchoolSelect = ({ name, schoolIdFieldId, onSchoolChange }) => {
  const [district, setDistrict] = useState();
  const [school, setSchool] = useState();

  const onSchoolSelect = useCallback((schoolId) => {
    const hiddenField = document.getElementById(schoolIdFieldId);
    if (hiddenField) {
      hiddenField.value = schoolId;
      // Dispatch a change event so other scripts can detect the change
      const event = new Event('change', { bubbles: true });
      hiddenField.dispatchEvent(event);
      
      // Call the callback if provided
      if (onSchoolChange) {
        onSchoolChange(schoolId);
      }
      
      // Also directly call the pre-fill function if it exists (for backward compatibility)
      if (window.fetchPreviousYearData && schoolId) {
        console.log('React component calling fetchPreviousYearData for school:', schoolId);
        window.fetchPreviousYearData(schoolId);
      }
    }
  }, [schoolIdFieldId, onSchoolChange]);

  const changeSchoolHandler = (opt) => {
    setSchool(opt);
    onSchoolSelect(opt.value);
  };

  const changeDistrictHandler = (opt) => {
    setDistrict(opt);
    setSchool(null);
  };

  const loadSchoolOptionsQuery = () => (value, callback) => {
    School.where({
      district_id: district.value,
      name: { match: value },
    })
      .order({ name: 'asc' })
      .per(50)
      .all()
      .then((res) => {
        const options = res.data.map((e) => ({ label: e.name, value: e.id, data: e }));
        callback(options);
      });
  };

  const loadDistrictOptionsQuery = () => (value, callback) => {
    District.where({
      name: { match: value },
    })
      .order({ name: 'asc' })
      .per(50)
      .all()
      .then((res) => {
        const options = res.data.map((e) => ({ label: e.name, value: e.id, data: e }));
        callback(options);
      });
  };

  return (
    <>
      <div className="form-group">
        <label htmlFor="district" className="control-label">District</label>
        <AsyncSelect
          cacheOptions
          defaultOptions
          placeholder="Select District (type to search)"
          value={district}
          name="district"
          loadOptions={loadDistrictOptionsQuery()}
          onChange={changeDistrictHandler}
          className="form-control-select"
        />
      </div>

      {district && (
        <div className="form-group">
          <label htmlFor={name} className="control-label">School</label>
          <AsyncSelect
            cacheOptions
            defaultOptions
            placeholder="Select School (type to search)"
            value={school}
            name={name}
            key={district?.value}
            loadOptions={loadSchoolOptionsQuery()}
            onChange={changeSchoolHandler}
            className="form-control-select"
          />
        </div>
      )}
    </>
  );
};

DistrictSchoolSelect.propTypes = {
  name: PropTypes.string,
  schoolIdFieldId: PropTypes.string.isRequired,
  onSchoolChange: PropTypes.func,
};

DistrictSchoolSelect.defaultProps = {
  name: 'school',
};

export default DistrictSchoolSelect;
